export default __webpack_public_path__ + "static/message-card-light-e8e2f1bc8666d9e0ac10f216ff89e5fac71d0bb734579f22a57c35b967e697e3.png";